import React from 'react';
import { styles } from './RefinementTag.css';

interface RefinementTagProps {
  label: string;
  handleTagRemoval: (e: any) => void;
}

const RefinementTag = ({ label, handleTagRemoval }: RefinementTagProps) => {
  return (
    <div className={styles.tagBody}>
      <img
        src={
          'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0zNjI2IDE4MDAuNTcyIDEyLjQyOCAxMi40MjgiPjxwYXRoIGQ9Ik0tMzYxMy45IDE4MDIuNDM2bC00LjM1IDQuMzUgNC4zNSA0LjM1YTEuMTQgMS4xNCAwIDAgMSAuMzI5Ljc2OGMuMDA2LjI5NC0uMTA4LjU3Ny0uMzE1Ljc4NXMtLjQ5LjMyMi0uNzg1LjMxNWExIDEgMCAwIDEtLjc2OC0uMzI5bC00LjM1LTQuMzUtNC4zNDcgNC4zNDdhMSAxIDAgMCAxLS43NjguMzI5Yy0uMjk0LjAwNi0uNTc3LS4xMDgtLjc4NS0uMzE1cy0uMzIyLS40OS0uMzE1LS43ODVhMSAxIDAgMCAxIC4zMjktLjc2OGw0LjM1LTQuMzUtNC4zNDYtNC4zNDdhMSAxIDAgMCAxLS4zMjktLjc2NGMtLjAwNi0uMjk0LjEwOC0uNTc3LjMxNS0uNzg1cy40OS0uMzIyLjc4NS0uMzE1YTEgMSAwIDAgMSAuNzY4LjMyOWw0LjM1IDQuMzUgNC4zNS00LjM1YTEgMSAwIDAgMSAuNzY0LS4zMjljLjI5NC0uMDA2LjU3Ny4xMDguNzg1LjMxNXMuMzIyLjQ5LjMxNS43ODVhMSAxIDAgMCAxLS4zMjkuNzY4eiIvPjwvc3ZnPg=='
        }
        className={styles.tagIcon}
        onClick={e => handleTagRemoval(e)}
      />
      <span className={styles.tagName}>{label}</span>
    </div>
  );
};

export default RefinementTag;
